import type { FrontModule } from "@core/modules";
import "./gestion.css";
import { BanquePage, ConsentementPage } from "./banque";
import { LeaseChargesTab, LeaseInsuranceTab, LeaseRentTab, LeaseRevisionTab } from "./bail";
import { ChargesPage } from "./charges";
import { CourriersPage } from "./courriers";
import { Dashboard } from "./dashboard";
import { DemarchesPage } from "./demarches";
import { TenantInsuranceSection, TenantRentSection } from "./locataire";
import { LoyersPage } from "./loyers";
import { PaiementsPage } from "./paiements";
import { QuittancesPage } from "./quittances";
import { ImpayePage, RelancesPage } from "./relances";
import { RevisionsPage } from "./revisions";

// Module « gestion » : échéancier et appels de loyer, paiements et import bancaire, connexion bancaire (simulateur),
// règlements partiels et aides, quittances et reçus, relances, assurance habitation, charges et TEOM, révision,
// démarches CAF et déclaration d'occupation guidées, impayés et échéancier amiable, courriers et recommandés.
export const module: FrontModule = {
  name: "gestion",
  orgRoutes: [
    { path: "loyers", element: <LoyersPage /> },
    { path: "gestion/paiements", element: <PaiementsPage /> },
    { path: "gestion/banque", element: <BanquePage /> },
    { path: "gestion/banque/consentement", element: <ConsentementPage /> },
    { path: "gestion/quittances", element: <QuittancesPage /> },
    { path: "gestion/relances", element: <RelancesPage /> },
    { path: "gestion/impayes/:caseId", element: <ImpayePage /> },
    { path: "gestion/charges", element: <ChargesPage /> },
    { path: "gestion/revisions", element: <RevisionsPage /> },
    { path: "gestion/courriers", element: <CourriersPage /> },
    { path: "gestion/demarches", element: <DemarchesPage /> },
  ],
  nav: [
    { to: "loyers", label: "Loyers", section: "Gestion", perm: "read", order: 20 },
    { to: "gestion/paiements", label: "Paiements", section: "Gestion", perm: "read", order: 21 },
    { to: "gestion/banque", label: "Banque", section: "Gestion", perm: "read", order: 22, hideWhenRestricted: true },
    { to: "gestion/quittances", label: "Quittances", section: "Gestion", perm: "read", order: 23 },
    { to: "gestion/relances", label: "Relances et impayés", section: "Gestion", perm: "read", order: 24 },
    { to: "gestion/charges", label: "Charges", section: "Gestion", perm: "read", order: 25, hideWhenRestricted: true },
    { to: "gestion/revisions", label: "Révisions", section: "Gestion", perm: "read", order: 26, hideWhenRestricted: true },
    { to: "gestion/courriers", label: "Courriers", section: "Gestion", perm: "read", order: 27 },
    { to: "gestion/demarches", label: "Démarches", section: "Gestion", perm: "read", order: 28 },
  ],
  Dashboard,
  leaseTabs: [
    { id: "gestion-loyers", label: "Loyers", order: 20, Component: LeaseRentTab },
    // Charges et révisions sont des opérations sur tout le portefeuille : refusées à un collaborateur restreint.
    { id: "gestion-charges", label: "Charges", order: 21, Component: LeaseChargesTab, hideWhenRestricted: true },
    { id: "gestion-revision", label: "Révision", order: 22, Component: LeaseRevisionTab, hideWhenRestricted: true },
    { id: "gestion-assurance", label: "Assurance", order: 23, Component: LeaseInsuranceTab },
  ],
  tenantSections: [
    { id: "gestion-loyers", label: "Mes loyers et quittances", order: 20, Component: TenantRentSection, visible: ({ role }) => role === "locataire" },
    { id: "gestion-assurance", label: "Mon assurance", order: 21, Component: TenantInsuranceSection, visible: ({ role }) => role === "locataire" },
  ],
};
